import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { SpendResponseModel } from '@/types/clarityLens'

export const getSpend = async (
  branchName: string,
  startDate: string,
  endDate: string,
  itemName: string
): Promise<SpendResponseModel> => {
  try {
    const response = await axios.get(`${BASE_URL}/spend-lens/item/spend`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        dcn: branchName,
        item_name: itemName,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
